export default {"src":"/_next/static/media/1.82c65af5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};